import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardContent, CardActionArea} from 'views/components';
import {Typography, Stack} from 'views/components';

import {Translate} from 'views/module';

const Card = (props) => {
  const item = props.item;

  const clientLeadRn = item.clientLeadRn;
  const clientLeadName = item.clientLeadName;
  const status = item.status;


  return (
    <React.Fragment>
      <CardActionArea
        sx={{
          textAlign: 'left',
        }}
        to={`/client_lead/${clientLeadRn}`}
      >
        <CardContent>
          <Typography variant="h5" component="div">
            {clientLeadName}
          </Typography>
          <Stack direction={'row'}>
            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
              <Translate expression={`clientLead.ClientLeadList.ClientLeadStatus`} />
              <Translate expression={`clientLead.Status.${status}.Title`} />
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </React.Fragment>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
